import { render } from "./AgendaPage.vue?vue&type=template&id=63e866ab&scoped=true"
import script from "./AgendaPage.vue?vue&type=script&lang=js"
export * from "./AgendaPage.vue?vue&type=script&lang=js"

import "./AgendaPage.vue?vue&type=style&index=0&id=63e866ab&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e866ab"]])

export default __exports__